import React from 'react'
export default function UserProfileLink(props) {
  return (
    <a href={`/profile/public/${props.userId}`} className="user-profile-link">
      {props.firstName} {props.lastName}
    </a>
  );
}



// WEBPACK FOOTER //
// ./assets/es6/view_invitation/common/components/user-profile-link.es6